import {Entity} from '@s-ui/domain'

export class DealerEntity extends Entity {
  /**
   * @constructor
   * @param {Object} data
   * @param {String} data.externalContractId
   * @param {String} data.externalPageUrl
   * @param {Boolean} data.hasCallTrackingService
   * @param {Boolean} data.hasFinancingProduct
   * @param {Boolean} data.hasReservation
   * @param {Boolean} data.hasWhatsappProduct
   * @param {String} data.id
   * @param {LocationValueObject} data.location
   * @param {String} data.logoImageUrl
   * @param {Boolean} data.mainRentingServicesIncluded
   * @param {String} data.moreInformation
   * @param {String} data.name
   * @param {String} data.pack
   * @param {String} data.phoneNumber
   * @param {Object} data.ratings
   * @param {Array<DealerEntity>} data.relatedStores
   * @param {Object} data.schedule
   * @param {Array<DealerServiceValueObject>} data.services
   * @param {String} data.stockPageUrl
   * @param {String} data.isActive
   * @param {Boolean} data.brandingActive
   * @param {Boolean} data.showContactLogo
   * @param {Boolean} data.showDealerDirections
   * @param {Number|null} data.predictionScore
   * @param {Array<String>} data.storeImageUrls
   * @param {Number} data.totalPublishedVehicles
   * @param {String} data.type
   * @param {Array} data.videos
   */

  /**
   * Validation method
   * @param {Object} param
   * @param {String} param.id
   * @param {DealerError} param.invalidContractErrorFactory
   */
  static validate({id, invalidDealerErrorFactory}) {
    const hasId = Boolean(id)

    if (!hasId) {
      throw invalidDealerErrorFactory('Dealer does not have an ID')
    }
  }

  get value() {
    return {
      allowOnlineAppointment: this._allowOnlineAppointment,
      externalContractId: this._externalContractId,
      externalPageUrl: this._externalPageUrl,
      id: this._id,
      isRecommended: this._isRecommended,
      hasCallTrackingService: this._hasCallTrackingService,
      hasFinancingProduct: this._hasFinancingProduct,
      hasReservation: this._hasReservation,
      hasWhatsappProduct: this._hasWhatsappProduct,
      hidePhone: this._hidePhone,
      location: this._location.toJSON(),
      logoImageUrl: this._logoImageUrl,
      mainRentingServicesIncluded: this._mainRentingServicesIncluded,
      sellerMessagingId: this._sellerMessagingId,
      moreInformation: this._moreInformation,
      name: this._name,
      brandingActive: this._brandingActive,
      showContactLogo: this._showContactLogo,
      showDealerDirections: this._showDealerDirections,
      pack: this._pack,
      phoneNumber: this._phoneNumber,
      ratings: this._ratings,
      relatedStores: this._relatedStores,
      schedule: this._schedule,
      services: this._services,
      stockPageUrl: this._stockPageUrl,
      storeImageUrls: this._storeImageUrls,
      isActive: this._isActive,
      predictionScore: this._predictionScore,
      totalPublishedVehicles: this._totalPublishedVehicles,
      type: this._type,
      videos: this._videos
    }
  }

  getId() {
    return this._id
  }
}
